module.exports = "data:image/jpeg;base64,UklGRi4AAABXRUJQVlA4TCEAAAAv/kAqAA8w//M///MfWiCTtqnzSt89AyWi/xNAnt7b/gQA"


//////////////////
// WEBPACK FOOTER
// ./src/statics/images/flag/lang-id.jpg
// module id = W5Ro
// module chunks = 44